// What a talking face can show: a mouth shape for each moment of speech, and a feeling.
import type { FaceTurn } from "./faceStyles";

export type Viseme = "A" | "B" | "C" | "D" | "E" | "F" | "G" | "H" | "X";
export type Cue = { start: number; end: number; value: Viseme };

export type Emotion = "neutral" | "happy" | "angry" | "sad" | "surprised" | "smug";
export const EMOTIONS: Emotion[] = ["neutral", "happy", "angry", "sad", "surprised", "smug"];

// A face part's centre and width, in its picture's pixels. Eyes and brows are drawn at that width; the rest of each
// sprite set keeps its own relative scale.
export type Spot = { x: number; y: number; w: number };
export type FaceSpots = { eyes: Spot; brows: Spot; mouth: Spot; tilt?: number; turn?: FaceTurn }; // tilt: degrees clockwise, spots already turned; turn: looking 45° left or right (none: straight on)
